// src/UltimateHome.js
import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import WorkSection from './components/WorkSection';
import './UltimateHome.css';
import { ScrollContext } from './components/ScrollContext';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';

import sza from './components/CardContent/SZAPortal/logo (4).png';

const UltimateHome = () => {
  const token = Cookies.get('token');
  const containerRef = useRef(null);
  const [isRefReady, setIsRefReady] = useState(false);
  const sectionRefs = useRef({});

  useEffect(() => {
    if (containerRef.current) {
      setIsRefReady(true);
    }
  }, []);

  const registerSection = useCallback((id, element) => {
    if (element) {
      sectionRefs.current[id] = element;
      console.log(`[UltimateHome] ✅ Registered section: ${id}`);
    }
  }, []);

  // ✅ UPDATED SCROLL-TO FUNCTION
  const scrollTo = useCallback((id) => {
    const container = containerRef.current;
    const targetElement = sectionRefs.current[id];

    // Ensure both the container and target element are available
    if (container && targetElement) {
      console.log(`[UltimateHome] 🚀 Scrolling to: ${id} with -4vh offset.`);

      // 1. Calculate the target's top position relative to the scroll container
      const targetPosition = targetElement.offsetTop;

      // 2. Calculate the 4vh offset in pixels.
      // window.innerHeight gives us the height of the viewport.
      const offsetInPixels = (10 / 100) * window.innerHeight;

      // 3. Determine the final scroll position by subtracting the offset
      const finalScrollPosition = targetPosition - offsetInPixels;

      // 4. Use the container's `scrollTo` method for precise positioning
      container.scrollTo({
        top: finalScrollPosition,
        behavior: 'smooth',
      });

    } else {
      console.warn(`[UltimateHome] 🟡 Scroll target or container not found for id: ${id}`);
    }
  }, []); // Dependencies are empty because it relies on refs and window, not props/state

  const contextValue = useMemo(() => ({
    containerRef,
    registerSection,
    scrollTo,
  }), [registerSection, scrollTo]);

  return (
    <ScrollContext.Provider value={contextValue}>
      <div className="ULTHOME-container" ref={containerRef}>
        
        {/* Color screen fade-in overlay */}
        <motion.div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#1f1f1e',
            zIndex: 9999,
            pointerEvents: 'none'
          }}
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ 
            duration: 1, 
            delay: 0,
            ease: "easeInOut"
          }}
        />

        {/* Header */}
        <motion.header 
          className="ULTHOME-header"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ 
            duration: 1.2, 
            delay: 0.3,
            ease: [0.25, 0.46, 0.45, 0.94]
          }}
        >
<motion.div
  className="ULTHOME-logo"
  initial={{ scale: 0.8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
>
  <img src={sza} alt="Logo" />
</motion.div>

          
          <motion.div
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ 
              duration: 1, 
              delay: 1,
              ease: "easeOut"
            }}
          >
          {token ? (
              <Link to="/dashboard" className="ULT-login">
                  Go to Dashboard
              </Link>
          ) : (
              <Link to="/login" className="ULT-login">
                  Log In
              </Link>
          )}          
          </motion.div>
        </motion.header>

        {isRefReady && (
          <>
            <HeroSection />
            <WorkSection />
          </>
        )}
      </div>
    </ScrollContext.Provider>
  );
};

export default UltimateHome;